{
  "settings": {
    "2fa": {
      "buttons": {
        "disable": "Inaktivera",
        "setUp": "Aktivera",
        "yesDisable": "Ja, inaktivera"
      },
      "characterCode": "6-siffrig kod",
      "description2FaOff": "Öka säkerheten för ditt konto. För att logga in måste du ange en kod tillsammans med ditt användarnamn och lösenord.",
      "description2FaOn": "Du har aktiverat tvåfaktorsautentisering. För att logga in måste du ange en kod (levereras via app eller SMS) tillsammans med ditt användarnamn och lösenord.",
      "disableDesc": "Detta minskar säkerhetsnivån för ditt konto och rekommenderas inte. Är du säker på att du vill fortsätta?",
      "disableTitle": "Inaktivera tvåfaktorsautentisering",
      "header": "2FA",
      "orCopy": "Eller kopiera koden för manuell inmatning:",
      "qrCodeDesc": "Använd en autentiseringsapp som Google Authenticator, skanna QR-koden.",
      "setUpLong": "Ställ in tvåfaktorsautentisering",
      "title": "Tvåfaktorsautentisering",
      "verificationDesc": "När du har anslutit din app, ange din senaste sexsiffriga verifieringskod för North House.",
      "restore": {
        "title": "Behöver du hjälp med att komma åt ditt konto?",
        "description": "Om du inte kan komma åt ditt konto på grund av problem med tvåfaktorsautentisering, vänligen kontakta vårt supportteam på support@northhouse.se eller ring +46 (0)8 50 23 52 22"
      },
      "copy": "Kopiera"
    },
    "header": "Inställningar",
    "password": {
      "current": "Nuvarande lösenord",
      "enterCurrent": "Ange nuvarande lösenord",
      "enterNew": "Ange nytt lösenord",
      "header": "Lösenord",
      "mustContain": "Måste innehålla minst 8 tecken varav 1 versal, 1 gemen och 1 siffra.",
      "new": "Nytt lösenord",
      "repeat": "Upprepa nytt lösenord",
      "noMatch": "Lösenorden matchar inte",
      "tooShort": "Lösenordet måste vara minst 8 tecken långt",
      "needsUppercase": "Lösenordet måste innehålla minst en versal",
      "needsLowercase": "Lösenordet måste innehålla minst en gemen",
      "needsNumber": "Lösenordet måste innehålla minst en siffra"
    },
    "profile": {
      "avatar": "Avatar",
      "changeImage": "Ändra",
      "header": "Profil",
      "role": "Din roll"
    },
    "roleDescription": {
      "superadmin": "Administratör för platformen. Kan läsa och tilldelas roller i alla dokument.",
      "coordinator": "Kan äga, läsa och tilldelas roller i alla dokument.",
      "contributor": "Kan äga, läsa och tilldelas roller i dokument som är i samma kategori som användaren.",
      "reader": "Kan läsa dokument som är i samma kategori som användaren."
    },
    "userManagement": {
      "activateUser": "Aktivera användare",
      "deleteUser": "Ta bort användare",
      "deleteUserSupText": "Är du säker på att du vill ta bort följande användare?",
      "descriptionPartDisable": "Är du säker på att du vill inaktivera denna användare?",
      "descriptionPartEnable": "Är du säker på att du vill aktivera denna användare?",
      "disableUser": "Inaktivera användare",
      "search": "Sök användare...",
      "title": "Användare",
      "addUser": {
        "title": "Lägg till användare"
      },
      "editUser": {
        "title": "Redigera användare"
      },
      "offboardInstruction": "Användaren är ägare eller publicerare av följande dokument. Tilldela dessa roller till andra användare och inaktivera sedan användaren.",
      "offboardSuccess": "Användaren har inaktiverats",
      "offboardWorkflowWarningTitle": "Arbetsflödestilldelningar kommer att tas bort",
      "offboardWorkflowWarningDescription": "När användaren inaktiveras tas den även bort från alla arbetsflödessteg i dokumentutkast och från arbetsflödesmallar. Publicerade och arkiverade dokumentversioner påverkas inte."
    }
  }
}
